import React, { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { useFlexLayout, useTable } from 'react-table';

import { FlexRow } from 'ui-components/components/flex';
import { Text } from 'ui-components/components/text';

import { columns } from './columns';
import { NameColumnId } from './name-column';
import style from './order-items.module.less';
import { QuantityColumnId } from './quantity-column';
import { useEntitiesSalesOrder } from '../../../../../hooks/entities/selectors/sales-orders';
import { useSalesOrderIdContext } from '../../../../context/sales-order-id-context-provider';
import messages from '../messages';

const emptyItems = [];

const OrderItems = () => {
  const salesOrderId = useSalesOrderIdContext();
  const salesOrder = useEntitiesSalesOrder(salesOrderId) ?? {};

  const items = salesOrder.items ?? emptyItems;
  const zeroItems = !items.length;

  const formattedData = useMemo(
    () =>
      items.map((item) => {
        return {
          [NameColumnId]: { name: item.name },
          [QuantityColumnId]: { quantity: item.quantity },
        };
      }),
    [items],
  );

  const { getTableProps, headerGroups, getTableBodyProps, rows, prepareRow } = useTable(
    {
      columns,
      data: formattedData,
    },
    useFlexLayout,
  );

  const { getHeaderGroupProps, headers } = headerGroups[0];

  return (
    <div>
      <div {...getTableProps()}>
        <div {...getHeaderGroupProps()} className={style['header-row']}>
          {headers.map((column) => {
            const { key, ...rest } = column.getHeaderProps();
            return (
              <div key={key} {...rest}>
                {column.render('header')}
              </div>
            );
          })}
        </div>
        {zeroItems ? (
          <FlexRow className={style['zero-items-placeholder']}>
            <Text textType='Paragraph' value={<FormattedMessage {...messages.orderItemsEmptyOrder} />} />
          </FlexRow>
        ) : (
          <div {...getTableBodyProps()} className={style['body-rows']}>
            {rows.map((row) => {
              prepareRow(row);
              const { key: rowKey, ...rowProps } = row.getRowProps();
              return (
                <div key={rowKey} {...rowProps} className={style['body-row']}>
                  {row.cells.map((cell) => {
                    const { key: cellKey, ...cellProps } = cell.getCellProps();
                    return (
                      <div key={cellKey} {...cellProps}>
                        {cell.render('cell')}
                      </div>
                    );
                  })}
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default OrderItems;
